(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fl-reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewsSection extends HTMLElement {
    constructor() {
      super();
      this.grid = this.querySelector('[data-reviews-grid]');
      this.progressBar = this.querySelector('[data-progress-bar]');

      this.initMobileScroll();
    }

    initMobileScroll() {
      if (!this.grid || !this.progressBar) return;

      this.grid.addEventListener('scroll', () => {
        const scrollWidth = this.grid.scrollWidth - this.grid.clientWidth;
        const scrolled = this.grid.scrollLeft;
        const progress = (scrolled / scrollWidth) * 100;
        
        this.progressBar.style.width = `${progress}%`;
      });
    }
  }
  
  customElements.define('reviews-section', ReviewsSection);

  } catch(e) { console.error(e); }
})();
})();
